import { gql } from "@apollo/client";

export const SAVE_FINANCIER_LOAN_APPROVAL = gql`
  mutation SaveFinancerLoanApproval($flaInput: FinancierLoanApprovalInput!) {
    saveFinancerLoanApproval(flaInput: $flaInput) {
      message
      is_valid
    }
  }
`;